import React from 'react';
import { Typography, Box } from '@mui/joy';
import { IonIcon } from '@ionic/react';
import { sparkles, timeOutline, sunny } from 'ionicons/icons';
import { useSessionInactivity } from '../../../hooks/useSessionInactivity';
import SessionWarningModal from '../SessionWarningModal/SessionWarningModal';
import { useHistory } from 'react-router-dom';
import Tooltip from '@mui/material/Tooltip';

const WelcomeHeader = ({ paciente }) => {
  const history = useHistory();

  // Función para obtener saludo basado en la hora
  const getSaludo = () => {
    const hora = new Date().getHours();
    if (hora < 12) return { texto: 'Buenos días', icono: sunny };
    if (hora < 18) return { texto: 'Buenas tardes', icono: timeOutline };
    return { texto: 'Buenas noches', icono: sparkles };
  };

  const saludo = getSaludo();

  // Función para manejar logout
  const handleLogout = () => {
    console.log('🚪 [WelcomeHeader] Ejecutando logout...');
    
    try {
      // Limpiar localStorage/sessionStorage
      localStorage.removeItem('token');
      localStorage.removeItem('usuario');
      localStorage.removeItem('paciente');
      sessionStorage.clear();
      
      console.log('🧹 [WelcomeHeader] Datos limpiados del storage');
      
      // Redirigir al login - probamos diferentes rutas
      console.log('🔄 [WelcomeHeader] Redirigiendo al login...');
      
      // Forzar recarga completa para asegurar limpieza de estado
      setTimeout(() => {
        window.location.href = '/login';
      }, 100);
      
      // También intentamos con history por si acaso
      history.push('/login');
      
    } catch (error) {
      console.error('❌ [WelcomeHeader] Error en logout:', error);
      // Fallback: forzar recarga a la raíz
      window.location.href = '/';
    }
  };

  // Función para manejar advertencia
  const handleWarning = () => {
    console.log('⚠️ Advertencia: Sesión próxima a expirar. Haga clic en cualquier parte para continuar.');
  };

  // Hook de monitoreo de sesión - Configuración de producción
  const {
    status,
    showWarningModal,
    formatTimeLeft,
    extendSession,
    forceLogout,
    statusConfig
  } = useSessionInactivity(
    4,    // 4 minutos para advertencia
    5,    // 5 minutos para logout automático
    handleLogout,
    () => console.log('⚠️ Advertencia: Sesión próxima a expirar')
  );

  return (
    <Box className="tech-welcome-header">
      <Box className="tech-welcome-content">
        <Box className="tech-welcome-icon">
          <IonIcon icon={saludo.icono} />
        </Box>
        <Box>
          <Typography className="tech-welcome-greeting">
            {saludo.texto}
          </Typography>
          <Typography className="tech-welcome-name">
            {paciente?.nombre ? `${paciente.nombre} ${paciente?.apellido}` : 'Bienvenido/a'}
          </Typography>
          <Typography className="tech-welcome-subtitle">
            Gestiona tu atención médica de forma inteligente
          </Typography>
        </Box>
      </Box>

      {/* Indicador de estado inteligente con Tooltip */}
      <Box className="tech-status-indicator" data-status={status} style={{ background: statusConfig.bgColor, borderColor: statusConfig.borderColor }}>
        {/* Tooltip de información de sesión activa */}
        <div style={{ width: '100%' }}>
          <Tooltip
            title="Su sesión dura hasta 10 minutos sin actividad. Al llegar a 9 minutos, verá una cuenta regresiva de 1 minuto antes del cierre automático. Haga click en la pantalla para mantener la sesión activa."
            placement="top"
            arrow
          >
            <Box
              display="flex"
              alignItems="center"
              gap={1}
              style={{
                cursor: 'pointer',
                background: 'linear-gradient(90deg, #16a34a 0%, #22c55e 100%)',
                color: '#fff',
                borderRadius: '20px',
                padding: '8px 20px',
                boxShadow: '0 2px 8px rgba(22, 163, 74, 0.15)',
                fontWeight: 700,
                fontSize: '1rem',
                transition: 'background 0.2s',
                minWidth: '180px',
                justifyContent: 'center'
              }}
            >
              <Box
                className="tech-status-dot"
                style={{
                  background: '#fff',
                  animation:
                    statusConfig.animation === 'pulse'
                      ? 'pulse 2s ease-in-out infinite'
                      : statusConfig.animation === 'blink'
                      ? 'blink 1s ease-in-out infinite'
                      : 'none',
                  marginRight: '8px',
                  width: '10px',
                  height: '10px',
                  borderRadius: '50%'
                }}
              ></Box>
              <Typography className="tech-status-text" sx={{ color: '#fff', fontWeight: 700 }}>
                {statusConfig.text}
              </Typography>
            </Box>
          </Tooltip>
        </div>
      </Box>

      {/* Modal de advertencia de sesión */}
      <SessionWarningModal
        isOpen={showWarningModal}
        timeLeft={formatTimeLeft}
        formatTimeLeft={formatTimeLeft}
        onExtendSession={extendSession}
        onForceLogout={forceLogout}
        onClose={() => {}} // No permitir cerrar manualmente
      />
    </Box>
  );
};

export default WelcomeHeader;